import { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { getEvents } from 'helper/api';
import { OutlineButton } from 'components/Button';
import { FullPageLoader } from 'components/Loaders';
import styles from './events.module.scss';
import postImg from 'assets/images/post.jpg';
import PageBanner from 'components/banners/PageBanner';
import { Helmet } from 'react-helmet';

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getEvents()
      .then((result) => {
        setLoading(false);
        if (result.status) {
          setEvents(result.events);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  return (
    <div className="content">
      <Helmet>
        <title>Events - CAP60</title>
        <meta
          name="description"
          content="Cap60 has organized many events in different countries in the era of data management. Join us Now!."
        />
        <meta name="keywords" content="event, cap60 events" />
      </Helmet>
      <PageBanner
        title="Our Events"
        subtitle="We are Setting the Stage for a Digital Experience for Nonprofit Organizations."
      />
      {loading && <FullPageLoader />}
      {events && events.length > 0
        ? events.map((item) => {
            return (
              <section key={item.id}>
                <div className={[styles.bgPost, 'py-5'].join(' ')}>
                  <Container>
                    <div className={styles.eventitem}>
                      <Row className="mb-3">
                        <Col md={8} className="mb-2">
                          <h5 className="font-s1 fw800">
                            Event: {item?.name?.text || ''}
                          </h5>
                          <h5 className="font-s1 fw800">
                            Description: {item?.description?.text || ''}
                          </h5>
                        </Col>
                        <Col md={4} className="text-md-right">
                          <Link to={`/event/${item.id}`}>
                            <OutlineButton>Read More</OutlineButton>
                          </Link>
                        </Col>
                      </Row>
                      <img
                        src={item?.logo?.original?.url || postImg}
                        className={styles.imgevent}
                        alt="Event"
                      />
                      <div className="textLight my-3">
                        <span>
                          {moment(item.start.utc).format('MMM, DD YYYY')}
                        </span>
                        {/* <span className={styles.dot}></span>
                          <span>By: Sean</span> */}
                      </div>
                      <p className="font-s1">{item.summary}</p>
                    </div>
                  </Container>
                </div>
              </section>
            );
          })
        : !loading && <h2>No events found!</h2>}
    </div>
  );
}
export default Events;
